import { render } from "./PractitionerNotActive.vue?vue&type=template&id=0eb262d5"
import script from "./PractitionerNotActive.vue?vue&type=script&lang=js"
export * from "./PractitionerNotActive.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/nuxt-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__